export const VISIBILITY_BADGE_TRANSLATION_KEYS = {
    shared: "si.common.visibility_badge.shared",
    private: "si.common.visibility_badge.private",
} as const;
